export const TravelExploreIcon = ({
  width = 48,
  height = 48,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3646_7794"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3646_7794)">
        <path
          d="M23.1885 42.969C20.6705 42.8613 18.3032 42.2928 16.0865 41.2635C13.8698 40.2338 11.9437 38.869 10.308 37.169C8.672 35.469 7.37833 33.4908 6.427 31.2345C5.47567 28.9782 5 26.5667 5 24C5 21.3743 5.49933 18.9058 6.498 16.5945C7.49667 14.2828 8.85117 12.2718 10.5615 10.5615C12.2718 8.85117 14.2828 7.49667 16.5945 6.498C18.9058 5.49933 21.3743 5 24 5C28.8383 5 33.0235 6.56033 36.5555 9.681C40.0878 12.8013 42.1745 16.6962 42.8155 21.3655H40.5155C40.0768 18.4372 38.9543 15.8122 37.148 13.4905C35.3417 11.1685 33.0437 9.44483 30.254 8.3195V9.2385C30.254 10.3925 29.8572 11.39 29.0635 12.231C28.2698 13.072 27.2962 13.4925 26.1425 13.4925H21.8885V17.746C21.8885 18.2987 21.6732 18.765 21.2425 19.145C20.8115 19.5253 20.3127 19.7155 19.746 19.7155H15.6345V24H20.577V30.173H17.746L7.7 20.146C7.559 20.787 7.452 21.429 7.379 22.072C7.306 22.7147 7.2695 23.3573 7.2695 24C7.2695 28.4617 8.7925 32.3097 11.8385 35.544C14.8845 38.7787 18.6678 40.4973 23.1885 40.7V42.969ZM42.346 41.977L35.473 35.142C34.8243 35.6293 34.1173 36 33.352 36.254C32.5867 36.5077 31.8098 36.6345 31.0215 36.6345C28.8982 36.6345 27.0913 35.8908 25.601 34.4035C24.1107 32.9165 23.3655 31.1133 23.3655 28.994C23.3655 26.875 24.1092 25.0738 25.5965 23.5905C27.0835 22.1072 28.8867 21.3655 31.006 21.3655C33.125 21.3655 34.9262 22.1107 36.4095 23.601C37.8928 25.0913 38.6345 26.8982 38.6345 29.0215C38.6345 29.8225 38.4993 30.609 38.229 31.381C37.9583 32.1527 37.5833 32.8732 37.104 33.5425L43.977 40.346L42.346 41.977ZM30.993 34.3655C32.4927 34.3655 33.763 33.8473 34.804 32.811C35.845 31.7747 36.3655 30.5067 36.3655 29.007C36.3655 27.5073 35.8473 26.237 34.811 25.196C33.7747 24.155 32.5067 23.6345 31.007 23.6345C29.5073 23.6345 28.237 24.1527 27.196 25.189C26.155 26.2253 25.6345 27.4933 25.6345 28.993C25.6345 30.4927 26.1527 31.763 27.189 32.804C28.2253 33.845 29.4933 34.3655 30.993 34.3655Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};
